import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-modal",
  style: {"width":"max-content"}
}
const _hoisted_2 = { class: "row-top mtop-02" }
const _hoisted_3 = {
  key: 0,
  class: "w-full mtop-06"
}
const _hoisted_4 = { style: {"margin":"0.2rem 0.5rem 0.2rem 0.1rem"} }
const _hoisted_5 = { class: "row gap-08" }

import { ref, watch, onMounted } from 'vue';
import interopluapi from '@/api/interopluapi';
import { useCurrentEntryStore } from '@/stores/currentEntry';


export default /*@__PURE__*/_defineComponent({
  __name: 'editMedicName',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore();
const emits = __emit;

const focusRef= ref(null);
const newSapName = ref("");
const galenicList = ref([]);

async function createGalenicList(){
  galenicList.value = []
  const expressionId = currentEntryStore.poppedSapExpr.expressionId
  let rawGalenicList = await interopluapi.getLuPackagings(expressionId)
  rawGalenicList = rawGalenicList
    .sort((a, b) => {return a.commercialName.localeCompare(b.commercialName) || a.dosage.localeCompare(b.dosage) || a.quantity.localeCompare(b.quantity)})
  galenicList.value = rawGalenicList
}

async function copySuggestionToFields(galenic) {
  currentEntryStore.setPoppedSapNewName(galenic.commercialName)
  currentEntryStore.setPoppedSapNewGalenic(galenic.galenic)
  emits('close')
}

async function changeMedicName() {
  currentEntryStore.setPoppedSapNewName(newSapName.value)
}

function innerFocus() {
  setTimeout(() => {
    focusRef.value.innerRef.focus()
  }, 1)
}

onMounted(() => {
  innerFocus()
})

watch(
  () => currentEntryStore.poppedSapExpr,
  () => {
    createGalenicList()
  },
  { immediate: true }
)

watch(
  () => currentEntryStore.poppedSapNewName,
  () => {
    newSapName.value = currentEntryStore.poppedSapNewName
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_inputBox, { style: {"width":"30rem"} }, {
        default: _withCtx(() => [
          _createVNode(_component_inputAreaAuto2, {
            ref_key: "focusRef",
            ref: focusRef,
            modelValue: newSapName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSapName).value = $event)),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (changeMedicName()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    (galenicList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_dbGroup, { style: {"max-height":"25rem","overflow-x":"hidden"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galenicList.value, (galenic, index) => {
                  return (_openBlock(), _createBlock(_component_list_group, {
                    key: index,
                    styles: "pad-s",
                    onClick: ($event: any) => (copySuggestionToFields(galenic))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_text_item, {
                          style: {"width":"16rem"},
                          txt: galenic.commercialName
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          style: {"width":"5rem"},
                          txt: galenic.galenic,
                          class: "mleft-06 main-m"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          style: {"width":"5rem"},
                          txt: galenic.dosage,
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          style: {"width":"3rem"},
                          txt: galenic.quantity,
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          style: {"width":"3rem"},
                          txt: galenic.price,
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          style: {"width":"2rem"},
                          txt: galenic.reimbursed,
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"]),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mleft-10" }, null, -1))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})